import React, { useEffect, useContext } from 'react';
import logo from '../../assets/marchetto-logo.svg';
import { useNavigate } from "react-router-dom";
import { loggedProfile, logout } from '../../redux/actions/userActions';
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom';
import { Context } from '../context/LanguageWrapper';
import { FormattedMessage } from 'react-intl';


const Header = () => {

    const context = useContext(Context)

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const userLogin = useSelector(state => state.userLogin)
    const { userDetails } = userLogin

    const profileList = useSelector((state => state.userProfile))
    const { loading, profile } = profileList

    useEffect(() => {
        dispatch(loggedProfile())
    }, [])

    let localLang = context.locale;

    const handleLogin = () => {
        navigate('/app/login');
    }

    const handleLogout = () => {
        dispatch(logout())
    }

    return (
        <>
            <header className="bg-green-900 text-white py-2 md:flex md:justify-between md:items-center p-8">
                <div className="flex md:p-0 place-content-center">
                    <Link to={'/app'}><img className='scale-100 h-8 md:h-10' src={logo} alt='logo' /></Link>
                </div>
                <nav className="md:flex flex-col md:flex-row justify-center md:mx-2">
                    <div className="flex items-center mt-2 md:mt-0 md:mx-2 place-content-center">
                        <span
                            className='inline-block mr-2 place-content-center'>
                            {loading ? ('') : (
                                <p className='text-white uppercase'>
                                    {loading === false && profile?.error !== "" ? (
                                        () => handleLogout()
                                    ) : (
                                        profile?.data?.name + " " + profile?.data?.surname
                                    )}
                                </p>)}
                        </span>
                    </div>
                    <div className="flex items-center mt-2 md:mt-0 md:mx-2 place-content-center">
                        <button className={localLang === 'it-IT' ? 'font-bold underline underline-offset-4' : ''} value={'it-IT'} onClick={context.selectLanguage}>IT</button>
                        <span className='ml-2 mr-2'>|</span>
                        <button className={localLang === 'en-GB' ? 'font-bold underline underline-offset-4' : ''} value={'en-GB'} onClick={context.selectLanguage}>EN</button>
                    </div>
                    <div className="flex items-center mt-2 md:mt-0 md:mx-2 place-content-center">
                        {Object.keys(userDetails || {})?.length > 0 ?
                            (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => handleLogout()}
                                        data-mdb-ripple="true"
                                        data-mdb-ripple-color="light"
                                        className="inline-block px-4 py-2.5 bg-gray-200 text-gray-700 font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out"
                                    ><FormattedMessage id="app.header.logout" defaultMessage="Logout" />
                                    </button>
                                </>
                            ) : (
                                <button
                                    type="button"
                                    onClick={() => handleLogin()}
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                    className="inline-block px-4 py-2.5 bg-gray-200 text-gray-700 font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:shadow-lg focus:bg-gray-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-400 active:shadow-lg transition duration-150 ease-in-out"
                                ><FormattedMessage id="app.header.login" defaultMessage="Login" />
                                </button>
                            )}
                        {/* <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Accedi</button>
                        <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-2">Esci</button> */}
                    </div>
                </nav>
            </header>
        </>
    );
};

export default Header;